// extracted by mini-css-extract-plugin
export var brain = "mission-module--brain--wlliq";
export var content = "mission-module--content--ph-zM";
export var effect = "mission-module--effect--xe+tC";
export var image = "mission-module--image--qbRPw";
export var isShow = "mission-module--isShow--mmaXB";
export var mission = "mission-module--mission--9jdVO";
export var text = "mission-module--text--YI9n3";
export var title = "mission-module--title--XEzpz";